module.exports = require('./helpers/bundle-url').getBundleURL('1JljX') + "lumoa.034c7273.png";